import React from 'react'
import { Formik, Field } from 'formik'
import { useDirectoryOptions } from 'lib/core/hooks'
import { DEFAULT_COUNTRY_CODE } from 'lib/core/resources/constants'
import { FlexWrapper, FadeIn, Form, Button } from 'lib/ui/components'
import { usePwaForm } from 'hooks/pwaForm'
import { FormValues, schema, validation } from './schema'
import { Wrapper } from './styled'

interface Prop {
  setIsModalOpen: (elem: boolean) => void
  contactType: 'resident_contact' | 'community_contact'
}

export const ContactUs = ({ setIsModalOpen, contactType }: Prop) => {
  const countryCode: string = DEFAULT_COUNTRY_CODE
  const { regionOptions } = useDirectoryOptions({ countryCode })
  const regionOptionsNotLoaded = regionOptions.length <= 1
  const isResident = contactType === 'resident_contact'

  const {
    submitForm,
    isFetching
  } = usePwaForm(contactType)

  const handleSubmit = (values: FormValues) => {
    const formFields = [
      { code: 'email', value: values.email },
      { code: 'name', value: values.name },
      { code: 'phone', value: values.phone_number },
      { code: 'comment', value: values.comment },
      { code: 'street', value: values.street },
      { code: 'city', value: values.city },
      { code: 'state', value: values.state },
      { code: 'zip_code', value: values.zip_code },
      { code: 'title', value: values.title },
      { code: 'community_name', value: values.community_name },
      { code: 'community_size', value: values.community_size }
    ]

    const handleSuccess = () => {
      setIsModalOpen(false)
    }

    submitForm(formFields, handleSuccess)
  }

  return (
    <FadeIn>
      <Wrapper>
        <FlexWrapper>
          <div>
            <Formik
              initialValues={schema}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {(formikProps: any) => {
                const { isValid } = formikProps
                return (
                  <div className='formQuote'>
                    <Form.Wrapper>
                      <FlexWrapper
                        className='row'
                      >
                        <Field
                          name='name'
                          label='Full Name'
                          component={Form.Input}
                          isRequired
                        />
                        {!isResident && (
                          <Field
                            name='title'
                            label='Title'
                            component={Form.Input}
                          />
                        )}
                      </FlexWrapper>

                      {!isResident && (
                        <FlexWrapper
                          className='row'
                        >
                          <Field
                            label='Community Name'
                            name='community_name'
                            component={Form.Input}
                          />
                          <Field
                            label='Community Size'
                            name='community_size'
                            component={Form.Select}
                            options={communitySize}
                          />
                        </FlexWrapper>
                      )}

                      <FlexWrapper
                        className='row'
                      >
                        <Field
                          label='Email'
                          name='email'
                          component={Form.Input}
                          isRequired
                        />
                        <Field
                          label='Phone'
                          name='phone_number'
                          component={Form.Input}
                          isRequired
                        />
                      </FlexWrapper>
                      <p>Address</p>
                      <FlexWrapper
                        className='row'
                      >
                        <Field
                          label='Street Address'
                          name='street'
                          component={Form.Input}
                        />
                        <Field
                          label='City'
                          name='city'
                          component={Form.Input}
                        />
                      </FlexWrapper>
                      <FlexWrapper
                        className='row'
                      >
                        <Field
                          label='State'
                          name='state'
                          component={Form.Select}
                          options={regionOptions}
                          isLoading={regionOptionsNotLoaded}
                        />
                        <Field
                          label='Zip Code'
                          name='zip_code'
                          component={Form.Input}
                        />
                      </FlexWrapper>

                      <Field
                        label='Comments or Questions'
                        name='comment'
                        component={Form.TextArea}
                      />
                      <Button
                        isLoading={isFetching}
                        isDisabled={!isValid}
                        type='submit'
                        color='alpha'
                        height={56}
                        padding={78}
                      >
                        Submit
                      </Button>
                    </Form.Wrapper>
                  </div>
                )
              }}
            </Formik>
          </div>
        </FlexWrapper>
      </Wrapper>
    </FadeIn>
  )
}

const communitySize = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Less than 100',
    value: 'Less than 100'
  },
  {
    label: '101 - 200',
    value: '101-200'
  },
  {
    label: '201 - 300',
    value: '201-300'
  },
  {
    label: '301 - 400',
    value: '301-400'
  },
  {
    label: '401 - 500',
    value: '401-500'
  },
  {
    label: '501 - 600',
    value: '501-600'
  },
  {
    label: '601 - 700',
    value: '601-700'
  },
  {
    label: '701 - 800',
    value: '701-800'
  },
  {
    label: '801 - 900',
    value: '801-900'
  },
  {
    label: '901 - 1,000',
    value: '901-1,000'
  },
  {
    label: 'More than 1,000',
    value: 'More than 1,000'
  }
]
